import PropTypes from 'prop-types'
import React from 'react'
import { Map } from 'immutable'
import { withFormsy as HOC } from 'formsy-react'
import { connect } from 'react-redux'
import { TextInput } from '../FormInput.v2/index'
import { FORM_INPUT_NAME_USERNAME } from '../../services/form/index'

function LoginUsername (props) {
  const {
    value,
    setValue,
    loginUsernameStaticText,
  } = props

  return (
    <div className="login-username__username-wrapper">
      <TextInput
        className="login-username__username"
        label={loginUsernameStaticText.getIn(['data', 'userNameOrEmail'])}
        onChange={(newValue) => setValue(newValue)}
        name={FORM_INPUT_NAME_USERNAME}
        value={value || ''}
        // eslint-disable-next-line jsx-a11y/tabindex-no-positive
        tabIndex="3"
        required
        autofocus
        autocomplete="username"
      />
    </div>
  )
}

LoginUsername.propTypes = {
  name: PropTypes.string,
  labelText: PropTypes.string,
}

const connectedLoginUsername = HOC(LoginUsername)
export default connect((state) => ({
  loginUsernameStaticText: state.staticText.getIn(
    ['data', 'loginUsername'],
    Map(),
  ),
}))(connectedLoginUsername)
